import { DME, DMEData } from "dmeditor";
import { nanoid } from "nanoid";
import { EntityClubInfo } from "./entity";
const definition: DME.Widget = {
  category: "bridge",
  icon: "bridge",
  name: "Club information",
  type: "bridge-club-information",
  events: {
    createBlock: (): DMEData.Block<EntityClubInfo> => {
      return {
        id: nanoid(),
        type: "bridge-club-information",
        data: {},
      };
    },
    updateData: () => {},
  },
  settings: [],
};

export default definition;
